import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex flex-1 items-center justify-center p-12">
      <div className="space-y-6 text-center">
        <p className="text-sm font-medium uppercase tracking-wide text-muted-foreground">
          404
        </p>
        <h1 className="text-3xl font-medium tracking-headline">Page not found</h1>
        <p className="text-sm text-muted-foreground">
          The page you were looking for moved or never existed.
        </p>
        <Button asChild>
          <Link to="/dashboard">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
